import React, { useState } from "react";
import AdminService from "src/services/admin.services";

const CreateAdmin: React.FC = () => {
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    password: "",
    phone: "",
    superadmin_email: "",
    superadmin_password: "",
  });

  const [modalMessages, setModalMessages] = useState<string[]>([]);
  const [showModal, setShowModal] = useState(false);

  const SUPERADMIN_EMAIL = "peakd@gmail.com";
  const SUPERADMIN_PASSWORD = "peakdelivery";

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const validationMessages: string[] = [];

    if (!/^[a-zA-Z]+$/.test(formData.last_name)) {
      validationMessages.push("Last name must contain only letters.");
    }

    if (formData.password.length < 8) {
      validationMessages.push("Password must be at least 8 characters long.");
    }

    if (formData.superadmin_email !== SUPERADMIN_EMAIL) {
      validationMessages.push("Invalid superadmin email.");
    }

    if (formData.superadmin_password !== SUPERADMIN_PASSWORD) {
      validationMessages.push("Invalid superadmin password.");
    }

    if (validationMessages.length > 0) {
      setModalMessages(validationMessages);
      setShowModal(true);
      return;
    }

    const lowerCaseFormData = {
      first_name: formData.first_name.toLowerCase(),
      last_name: formData.last_name.toLowerCase(),
      email: formData.email.toLowerCase(),
      password: formData.password.toLowerCase(),
      phone: formData.phone.toLowerCase(),
    };

    try {
      const adminService = new AdminService();
      const response = await adminService.createAdmin(lowerCaseFormData);

      if (response?.message === "admin created successfully") {
        setModalMessages(["Admin created successfully!"]);
      } else if (response?.error) {
        const errors = Array.isArray(response.error)
          ? response.error
          : [response.error];
        setModalMessages(errors);
      } else {
        setModalMessages(["Admin created successfully!"]);
      }
    } catch (error) {
      console.error("Error creating admin:", error);
      setModalMessages(["Admin created successfully!"]);
    } finally {
      setShowModal(true);
    }
  };

  const inputStyle =
    "w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-400 text-sm";

  return (
    <div className=" w-full flex items-center justify-center p-4">
      <div className="w-full max-w-lg bg-white shadow-xl rounded-xl p-6 space-y-6">
        <h2 className="text-2xl font-bold text-center text-amber-600">
          Create Admin
        </h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            placeholder="First Name"
            type="text"
            className={inputStyle}
            value={formData.first_name}
            onChange={(e) =>
              setFormData({ ...formData, first_name: e.target.value })
            }
          />
          <input
            placeholder="Last Name"
            type="text"
            className={inputStyle}
            value={formData.last_name}
            onChange={(e) =>
              setFormData({ ...formData, last_name: e.target.value })
            }
          />
          <input
            placeholder="Email"
            type="email"
            className={inputStyle}
            value={formData.email}
            onChange={(e) =>
              setFormData({ ...formData, email: e.target.value })
            }
          />
          <input
            placeholder="Password"
            type="password"
            className={inputStyle}
            value={formData.password}
            onChange={(e) =>
              setFormData({ ...formData, password: e.target.value })
            }
          />
          <input
            placeholder="Phone"
            type="text"
            className={inputStyle}
            value={formData.phone}
            onChange={(e) =>
              setFormData({ ...formData, phone: e.target.value })
            }
          />

          <div className="mt-6">
            <h3 className="text-sm font-medium mb-2 text-gray-600">
              Superadmin Credentials
            </h3>
            <input
              placeholder="Superadmin Email"
              type="email"
              className={inputStyle}
              value={formData.superadmin_email}
              onChange={(e) =>
                setFormData({ ...formData, superadmin_email: e.target.value })
              }
            />
            <input
              placeholder="Superadmin Password"
              type="password"
              className={inputStyle + " mt-3"}
              value={formData.superadmin_password}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  superadmin_password: e.target.value,
                })
              }
            />
          </div>

          <button
            type="submit"
            className="w-full bg-amber-500 text-white font-medium rounded-md py-3 hover:bg-amber-600 transition duration-300 mt-6"
          >
            Create Admin
          </button>
        </form>
      </div>

      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 px-4">
          <div className="bg-white rounded-xl p-6 max-w-md w-full shadow-lg space-y-4">
            {modalMessages.map((message, index) => (
              <p key={index} className="text-gray-800">
                {message}
              </p>
            ))}
            <button
              className="w-full bg-amber-500 text-white py-2 rounded-md hover:bg-amber-600"
              onClick={() => setShowModal(false)}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default CreateAdmin;
